import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import Form from "../../../components/form/components/Form/Form";
import FormField from "../../../components/form/components/FormField/FormField";
import Button from "../../../components/form/components/Button/Button";
import ErrorMessage from "../../../components/form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
import "./AssignModal.css";


import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { collection, arrayUnion, getDoc, getDocs, doc , updateDoc} from "firebase/firestore";
import { db } from "../../../firebase/firebase-config";

import { Select } from 'antd';

let { Option } = Select;

  const override = {
    marginTop: "20px",
  };


function AssignFeatureModal({  
    onClose,
    onContentAdded,  
    selectedSlide,
    featureId
}:any) {


    const [error, setError] = useState<any>(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    


    const handleAssignFeature = async (e:any) => {

        e.preventDefault()
  
        try{
          
          if(selectedPlan != null) {
            setLoading(true)
            const docRef = doc(collection(db,"Plans"),selectedPlan)
            const featureRef = doc(collection(db,"Features"),featureId)
            // Use getDoc() to fetch the document
            const docSnapshot = await getDoc(docRef);
            const featureSnapshot = await getDoc(featureRef);
        
            if (!docSnapshot.exists() || !featureSnapshot.exists()) {
              setLoading(false)
              throw new Error('Document does not exist!');
            }

            await updateDoc(docRef,{
              plan_features: arrayUnion(featureId)
            })

            setLoading(false)
        
            toast.success("Feature Assigned to Plan", {
              pauseOnHover: false,
              closeOnClick: true,
            });
          }
    
        }catch(e:any){
          console.log(e)
          console.error('Error updating array field:', error);
          toast.error("Error assigning feature to plan", {
            pauseOnHover: false,
            closeOnClick: true,
          });
        }
    
        
        if(selectedPlan)
          onClose()
      };

      const [allPlans, setAllPlans] = useState([]);
      
      const fetchData = async () => {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "Plans"));
        const subData: any = [];
    
        querySnapshot.forEach((doc) => {
          subData.push({
            id: doc.id,
            ...doc.data()
          })
        });
        
        // console.log('ALL  PLANS: ', subData)
        setAllPlans(subData)
    
        setLoading(false);
      };

      useEffect(() => {
        // Get all plans
        fetchData();
      },[])


      return (
        <div>
          <div  className="modal-container" id="assign-slide">
            <div className="modal-head">
              <p className="modal-title">Assign Feature to Plan</p>
              <ImCancelCircle
                style={{ cursor: "pointer" }}
                onClick={onClose}
                size={22}
                color="#fff"
              />
            </div>
            <div className="modal-content">
              <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <BeatLoader
                  color="#3080ED"
                  loading={loading}
                  cssOverride={override}
                />
              </div>
              <form action="" className="auth-form">
                {error && <ErrorMessage error={error} visible={true} />}
    
                  <p className="label-text">Select a Plan to assign feature to: </p>
                   <Select
                   className={'slide_select'}
                    
                    style={{ width: 200 }}
                    placeholder="Search to Select"
                    optionFilterProp="label"
                    popupClassName="dropDownItems"
                    // filterOption={(input: any, option: any) =>{
                    //   console.log(option)
                    //   return (option?.children as string)?.toLowerCase()?.includes((input as string)?.toLowerCase());
                    // }}
                    onSelect={(val: any) => setSelectedPlan(val)}
                    // filterSort={(optionA, optionB) =>
                    //   (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                    // }
                  >
                    
                  {allPlans.map((option: any, index: any) => (
                      <Option key={index} value={option.id}>
                        {option.name}
                      </Option>
                    ))}
                  </Select>

    
                  <br />
                  <br />
    
                  {!loading && (
                    <>
                      {/* <Button
                        isOutLined={true}
                        isFullWidth={false}
                        title="ADD REVIEWER"
                        onClick = {handleAddUser}
                      /> */}
    
                      <button
                        onClick = {handleAssignFeature}
                        style={{
                          padding: 15,
                          
                          border: "1px solid #000",
                          borderRadius: 5,
                          backgroundColor: "white",
                          textTransform: "uppercase",
                          cursor: 'pointer',
                          color: "#000",
                        }}
                      >
                        ASSIGN
                      </button>
    
                      <button
                        onClick={onClose}
                        style={{
                          padding: 15,
                          width: 100,
                          marginLeft: 25,
                          border: "1px solid #000",
                          borderRadius: 5,
                          backgroundColor: "white",
                          textTransform: "uppercase",
                          cursor: 'pointer',
                          color: "#000",
                        }}
                      >
                        Cancel
                      </button>
                    </>
                  )}
    
              </form>
            </div>
          </div>
          <div className="modal-shadow" onClick={onClose}></div>
        </div>
      );
}

export default AssignFeatureModal